import { api } from 'src/client/api';
import { storeSingleton } from 'src/client/store/storeSingleton';
import { setHasRouteError } from 'src/common/actions/app';
import useOnMount from 'src/common/hooks/useOnMount';
import { ERROR_404 } from '../../constants/localizations/app';
import Text from '../Text';
import ErrorPage from './ErrorPage';

const Error404 = () => {
  useOnMount(() => {
    api.telemetry.logError({
      message: 'Page Error 404',
      context: {
        url: window.location.pathname,
      },
    });
    storeSingleton.dispatch(setHasRouteError(true));

    return () => {
      storeSingleton.dispatch(setHasRouteError(false));
    };
  });

  return <ErrorPage httpStatusCode={404} message={<Text name={ERROR_404} />} />;
};

export default Error404;
